import React from 'react';
import {List, Layout, NavLink} from 'components';
import {config} from 'helpers';

export function Sidebar() {
  return (
    <Layout.Sidebar className="smaller">
      <List className="link-list">
        <NavLink to={`/${config.identityModule}/`} exact>Intro</NavLink>
        <NavLink to={`/${config.identityModule}/values/`}>1. Values</NavLink>
        <NavLink to={`/${config.identityModule}/beliefs/`}>2. Beliefs</NavLink>
        <NavLink to={`/${config.identityModule}/habits/`}>3. Habits</NavLink>
        <NavLink to={`/${config.identityModule}/strengths/`}>4. Strengths</NavLink>
        <NavLink to={`/${config.identityModule}/passion/`}>5. Passion</NavLink>
        <NavLink to={`/${config.identityModule}/purpose/`}>6. Purpose</NavLink>
        <NavLink to={`/${config.identityModule}/dreams/`}>7. Dreams</NavLink>
        <NavLink to={`/${config.identityModule}/vision/`}>8. Vision</NavLink>
      </List>
    </Layout.Sidebar>
  );
}
